import { render, staticRenderFns } from "./LiveEdit.vue?vue&type=template&id=47742c1e&scoped=true"
import script from "./LiveEdit.vue?vue&type=script&lang=js"
export * from "./LiveEdit.vue?vue&type=script&lang=js"
import style0 from "./LiveEdit.vue?vue&type=style&index=0&id=47742c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47742c1e",
  null
  
)

export default component.exports